import React, { useEffect, useState, useRef } from "react";
import { LayoutHome } from "../LayoutHome";
import { notification, Table, Button, Input, Space, Popconfirm } from "antd";
import {
  Checkbox,
  Form,
  Radio,
  Panel,
  SelectPicker,
} from "rsuite";
import {
  SearchOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { CalendarOutlined } from "@ant-design/icons";
import {
  getSpCitasProgramados,
  deleteProgramacion,
  getListaPacientes,
  saveProgramPaciente,
} from "../Services/ConsultasServices";

export const CitasProgramadas = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [api, contextHolder] = notification.useNotification();
  const initialized = useRef(false);

  const [idPaciente, setIdPaciente] = useState("0");
  const [listaPacientes, setListaPacientes] = useState([]);
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const [listaDias, setListaDias] = useState([]);
  const [hora, setHora] = useState("");
  const [nunca] = useState(true);

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{ padding: 8 }}
        onKeyDown={(e) => e.stopPropagation()}
        tabIndex={"-1"}
      >
        <Input
          ref={searchInput}
          autoFocus
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Resetear
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filtrar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Cerrar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const eliminaProgramacion = async (props) => {
    const data = {
      id: idNegocio,
      idPac: props.idPac,
    };
    await deleteProgramacion(data).then((res) => {
      if (res.status === 200) {
        successNotification(
          "Programación",
          "Se eliminó la programación correctamente",
        );
        loadCitasProgramadas();
      } else {
        errorNotificaction("Error al eliminar programación", res.data);
      }
    });
  };

  const columns = [
    {
      title: "ID Programación",
      dataIndex: "idProgram",
      width: "10%",
      key: "idProgram",
      align: "center",
    },
    {
      title: "Paciente",
      dataIndex: "nomPaciente",
      width: "35%",
      key: "nomPaciente",
      sorter: (a, b) => a.nomPaciente.length - b.nomPaciente.length,
      ...getColumnSearchProps("nomPaciente"),
    },
    {
      title: "Hora",
      dataIndex: "hora",
      key: "hora",
      align: "center",
    },
    {
      title: "Días",
      dataIndex: "Dias",
      width: "25%",
      key: "Dias",
      sorter: (a, b) => a.Dias.length - b.Dias.length,
      ...getColumnSearchProps("Dias"),
    },
    {
      title: "Acción",
      dataIndex: "x",
      width: "10%",
      key: "x",
      align: "center",
      render: (text, record) => (
        <Popconfirm
          title="Eliminar programación"
          description="¿Está seguro de que desea eliminar esta programación?"
          onConfirm={() =>
            eliminaProgramacion({
              noProgram: record.idProgram,
              idPac: record.idPaciente,
            })
          }
        >
          <Button icon={<DeleteOutlined style={{ color: "red" }} />} />
        </Popconfirm>
      ),
    },
  ];

  const loadPacientes = async () => {
    await getListaPacientes(idNegocio)
      .then((res) => {
        setListaPacientes(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const loadCitasProgramadas = async () => {
    await getSpCitasProgramados(idNegocio)
      .then((res) => {
        setData(res);
      })
      .catch((error) => {
        if (error.status === 401) {
          errorNotificaction(
            "Error de inicio",
            "Debe iniciar sesión, antes de continuar...",
          );
          setTimeout(() => {
            window.location = `/#/App`;
          }, 1200);
        } else {
          errorNotificaction(error.name, error.message);
        }
      });
  };

  const handleSelectedDia = (e, dia) => {
    if (e.target.checked) {
      setListaDias((prevDias) => [...prevDias, dia]);
    } else {
      const existe = listaDias.find((item) => item === dia);
      if (existe) {
        listaDias.splice(listaDias.indexOf(dia), 1);
        setListaDias([...listaDias]);
      }
    }
  };

  const saveProgramacion = async () => {
    const data = {
      id: idNegocio,
      idPaciente: idPaciente,
      hora: hora,
      listaDias: listaDias,
    }
    await saveProgramPaciente(data).then((res) => {
      if (res.status === 200) {
        successNotification(
          "Programación",
          "Se guardó la programación correctamente",
        );
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      } else {
        errorNotificaction("Error al guardar programación", res.data);
      }
    });
  }

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadCitasProgramadas().then((res) => {
        loadPacientes();
      });
    }
  }, []); // Empty dependency array ensures this effect runs only once on mount

  return (
    <div>
      <LayoutHome
        titleItems={[
          {
            title: (
              <a href="/#/App/Home" style={{ textDecoration: "none" }}>
                Menú
              </a>
            ),
          },
          { title: "Citas Programadas (Pacientes con recurrencia) " },
        ]}
        selectedKey={"CitasProgramadas"}
      >
        {contextHolder}
        <Panel
          bordered
          header="Configuración de programación de citas"
          style={{ marginBottom: 16 }}
        >
          <Form layout="inline">
            <Form.Group controlId="paciente">
              <Form.Label>Paciente</Form.Label>
              <SelectPicker
                block
                width={400}
                placeholder="--SELECCIONA--"
                data={listaPacientes}
                value={idPaciente}
                onChange={(value) => setIdPaciente(value)}
              />
            </Form.Group>

            <Form.Group controlId="hora">
              <Form.Label>Hora</Form.Label>
              <Input
                type="time"
                style={{ width: 120 }}
                placeholder="Hora"
                value={hora}
                onChange={(e) => setHora(e.target.value)}
              />
            </Form.Group>

            <Form.Group controlId="repetirEl">
              <br></br>
              <Form.Label>Repetir el</Form.Label>
              <Checkbox
                checked={listaDias.includes("1") ? true : false}
                onClick={(e) => handleSelectedDia(e, "1")}
              >
                L
              </Checkbox>
              <Checkbox
                checked={listaDias.includes("2") ? true : false}
                onClick={(e) => handleSelectedDia(e, "2")}
              >
                M
              </Checkbox>
              <Checkbox
                checked={listaDias.includes("3") ? true : false}
                onClick={(e) => handleSelectedDia(e, "3")}
              >
                R
              </Checkbox>
              <Checkbox
                checked={listaDias.includes("4") ? true : false}
                onClick={(e) => handleSelectedDia(e, "4")}
              >
                J
              </Checkbox>
              <Checkbox
                checked={listaDias.includes("5") ? true : false}
                onClick={(e) => handleSelectedDia(e, "5")}
              >
                V
              </Checkbox>
              <Checkbox
                checked={listaDias.includes("6") ? true : false}
                onClick={(e) => handleSelectedDia(e, "6")}
              >
                S
              </Checkbox>
            </Form.Group>
            <br></br>
            <Form.Group controlId="nunca">
              <Radio checked={nunca}>Nunca</Radio>
            </Form.Group>

            <Form.Group controlId="saveOk">
              <Form.Label></Form.Label>
              <Button
                type="primary"
                disabled={idPaciente === "0" ? true : false}
                icon={<CalendarOutlined />}
                onClick={saveProgramacion}
              >
                Guardar
              </Button>
            </Form.Group>
          </Form>
        </Panel>

        <Panel header="Pacientes - Citas Programadas" bordered>
          <Table
            bordered
            size="small"
            rowKey={(record) => record.idProgram}
            style={{ width: "100%" }}
            columns={columns}
            dataSource={data}
            pagination={{ pageSize: 20 }}
            scroll={{ y: 400 }}
          />
        </Panel>
      </LayoutHome>
    </div>
  );
};
